import {useEffect} from 'react';

export default function useBodyClass(bodyClass) {
    useEffect(() => {
        document.body.classList.add(bodyClass);
        return () => document.body.classList.remove(bodyClass);
    });

    return null;
}